import { useCallback } from 'react'
import { Alert, Button, Modal } from '../BaseComponents'
import { useNavigate } from 'react-router-dom'

const RouteAccessDeniedModal = ({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) => {
  const navigate = useNavigate()
  const goToDashboard = useCallback(() => {
    navigate('/dashboard')
    onClose()
  }, [navigate, onClose])
  const goToAccountSettings = useCallback(() => {
    navigate('/accounts')
    onClose()
  }, [navigate, onClose])
  return (
    <Modal open={open} onClose={goToDashboard} closeIcon>
      <Modal.Header />
      <Modal.Content>
        <Alert type="warn">
          Your current subscription does not include access to this feature. You
          can upgrade your plan in your Account Settings.
        </Alert>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={goToAccountSettings}>Go to Account Settings</Button>
        <Button onClick={goToDashboard}>Return to Dashboard</Button>
      </Modal.Actions>
    </Modal>
  )
}

export default RouteAccessDeniedModal
